module.exports = __webpack_public_path__ + "static/media/AmericaU_cert.7d24922d.jpg";